// extracted by mini-css-extract-plugin
export default {"lightNavLink":"Tab_lightNavLink__0HV1v","active":"Tab_active__B2QyS","darkNavLink":"Tab_darkNavLink__Bs69-"};